<template>
  <div>
    <v-btn
      @click.native="selectFile"
      v-if="downloadURL=='' && !uploading">
        {{$t('Upload a logo image')}}
        <v-icon
        right
        aria-hidden="true">
          mdi-camera-enhance
        </v-icon>
    </v-btn>
    <form ref="form">
      <input
        id="files"
        type="file"
        name="file"
        ref="uploadInput"
        accept="image/*"
        :multiple="false"
        @change="detectFiles($event)" />
    </form>
    <v-progress-circular
      v-if="uploading && !downloadURL==''"
      :size="70"
      :width="10"
      :rotate="360"
      :value="progressUpload"
      color="primary">
      {{progressUpload}}%
    </v-progress-circular>
    <img
      v-if="downloadURL"
      :src="downloadURL"
      width="60%" class="image-border" />
    <div v-if="downloadURL" class="justify-right">
        <v-tooltip top>
          <template v-slot:activator="{on}">
            <v-btn class="ma-0" icon color="error" v-on="on" @click="deleteImage()">
                <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </template>
          <span>{{$t('Remove Logo Image')}}</span>
        </v-tooltip>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/storage";

export default {
  name: "fileUploader",
  props: [
    "existingURL"
  ],
  data () {
    return {
      progressUpload: 0,
      fileName: "",
      uploadTask: "",
      uploading: false,
      downloadURL: "",
      storageRef: {},
      storedFileName: "images/logo"
    }
  },
  mounted() {
    this.storageRef = firebase.storage().ref();
    const user = this.$store.getters.getUser;
    this.storedFileName = "images/" + user.uid;
  },
  methods: {
    selectFile () {
      this.$refs.uploadInput.click()
    },
    detectFiles (e) {
      let fileList = e.target.files || e.dataTransfer.files
      Array.from(Array(fileList.length).keys()).map(x => {
        this.upload(fileList[x])
      })
    },
    upload (file) {
      this.uploading = true
      this.uploadTask = this.storageRef.child(this.storedFileName).put(file);
    },
    deleteImage () {
        this.storageRef.child(this.storedFileName)
        .delete()
        .then(() => {
          this.uploading = false
          this.downloadURL = ""
        })
        .catch(() => { //error
        //console.error(`file delete error occurred: ${error}`)
        })
      this.$refs.form.reset()
    }
  },
  watch: {
    existingURL: function() {
      this.downloadURL= this.existingURL
    },
    uploadTask: function () {
      this.uploadTask.on("state_changed", sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      },
      null,
      () => {
        this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          this.uploading = false;
          this.downloadURL = downloadURL
          this.$emit("downloadURL", downloadURL)
        })
      })
    }
  }
}
</script>

<style>
.progress-bar {
  margin: 10px 0;
}
input[type="file"] {
  position: absolute;
  clip: rect(0,0,0,0);
}
.image-border {
    border: 1px solid whitesmoke;
}
</style>